import Axios from '../components/Axios'

export const getStudiesList = (update) => {
	return Axios('POST', '/officialWeb/getStudiesList', update)
}
